import React from 'react';
import { Store } from 'redux'
import './App.scss';
import { AppState } from './store';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { History } from 'history'
import routes from './routes'
import Menu from './layouts/menu'
import Footer from './layouts/footer'

interface AppProps {
  store: Store<AppState, any>,
  history: History
}

class App extends React.Component<AppProps, {}> {
  
  render() {
    return (
      <Provider store={this.props.store}>
        <ConnectedRouter history={this.props.history}>
          <Menu />
          <div className="Content">
          {routes}
          </div>
          <Footer/>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;
